export default {
    state: {
        settingModel: null,
    },
    getters: {
        getNotificationSetting(state) {
            return state.settingModel;
        },
    },
    mutations: {
        putNotificationSetting(state, payload) {
            state.settingModel = payload;
        },
    },
    actions: {
        refreshNotificationSetting({ commit }, _payload) {
            commit("putNotificationSetting", null);
        },
        putNotificationSetting({ commit }, payload) {
            commit("putNotificationSetting", payload);
        },
    }
};
